import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function createAnimationRange(
  startAndEnd: number,
  maintain: number,
  step: number,
  length: number,
) {
  return [
    Array.from({ length }, (_, i) => parseFloat((i * step).toFixed(1))),
    Array.from({ length }, (_, i) => {
      if (i === 0 || i === length - 1) return startAndEnd;
      else return maintain;
    }),
  ];
}
